import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoSearchMagnifyingGlass = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>SearchMagnifyingGlass</title>
    <path
      d="M27.864 30.265a1 1 0 0 0 1.415-1.414l-1.415 1.415Zm1.415-1.414-6.857-6.856-1.415 1.414 6.857 6.857 1.415-1.415Z"
      fill="currentColor"
    />
    <circle cx={14.284} cy={15.272} r={10.857} stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
  </svg>
);
export default SvgIcoSearchMagnifyingGlass;
